export default __webpack_public_path__ + "static/media/ip.a5e158d6.svg";